import { Box, IconButton } from "@mui/material";
import { Icon } from "@iconify/react";
import moment from "moment";
export const HeaderConfig = [
  {
    label: "Sl No.",
    id: "sbNumber",
  },
  {
    label: "Release Date",
    id: "releaseDate",
    render: (data) => {
      return (
        <span>
          {data.releaseDate && moment(data.releaseDate).format("DD/MM/YYYY")}
        </span>
      );
    },
  },
  {
    label: "OEM",
    id: "oem",
    render: (data) => {
      return <span>{data?.oem?.name}</span>;
    },
  },
  {
    label: "Engine Model",
    id: "engineModel",
    render: (data) => {
      return (
        <Box sx={{ maxWidth: "400px", wordBreak: "break-all" }}>
          {data?.engineModel?.join(", ")}
        </Box>
      );
    },
  },
  {
    label: "List Numbers",
    id: "listNumbers",
    render: (data) => {
      return (
        <Box sx={{ maxWidth: "400px", wordBreak: "break-all" }}>
          {data?.listNumbers?.join(", ")}
        </Box>
      );
    },
  },
  {
    label: "Plant",
    id: "plantDetails",
    columns: [
      { label: "Cut in number", id: "cutInNumber" },
      {
        label: "Cut in date",
        id: "cutInDate",
      },
    ],
  },
  {
    label: "Subject",
    id: "subject",
  },
  {
    label: "Download",
    id: "download",
    render: (data, onClick) => {
      return (
        <IconButton onClick={() => onClick("DOWNLOAD", data)}>
          <Icon
            icon="tabler:download"
            width="1.5rem"
            height="1.5rem"
            style={{ color: "#095adc" }}
          />
        </IconButton>
      );
    },
  },
];
